export default "__VITE_ASSET__DdH5_mvN__"